import { combineReducers } from 'redux';
import pool from './pool';
import policy from './policy';

export default combineReducers({
    pool,
    policy,
});
